import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  ButtonContainer,
  ContentContainer,
  MessageContainer,
  PasswordFieldContainer
} from 'Pages/updatePassword/components/submitPassword/style';
import { Button, ButtonSizes, ButtonWidth } from 'Shared/components/design/button/Button';
import PasswordInput from 'Shared/components/design/passwordInput/PasswordInput';
import { TextFieldTypes } from 'Shared/components/design/textField/TextField';

type SubmitPasswordProps = {
  passwordCallback        : (input: string) => void;
  passwordBlur            : (input: string) => void;
  confirmPasswordCallback : (input: string) => void;
  confirmPasswordBlur     : (input: string) => void;
  isButtonDisabled        : boolean;
  submitPasswordCallback  : () => void;
  passwordFieldType       : TextFieldTypes;
  passwordHelperText?     : string;
  confirmPasswordFieldType: TextFieldTypes;
  confirmPasswordHelperText?: string;
  isLoading              : boolean;
}

/**
 * Renders SubmitPassword slide
 */
function SubmitPassword({
  passwordBlur,
  passwordCallback,
  confirmPasswordBlur,
  confirmPasswordCallback,
  isButtonDisabled,
  submitPasswordCallback,
  passwordFieldType,
  passwordHelperText,
  confirmPasswordFieldType,
  confirmPasswordHelperText,
  isLoading
}: SubmitPasswordProps): JSX.Element {
  const { t } = useTranslation('updatePassword');

  return (
    <ContentContainer>
      <MessageContainer tabIndex={0}>
        {t('UpdatePassword--submitPassword-message')}
      </MessageContainer>
      <PasswordFieldContainer>
        <PasswordInput
          blurCallback   = {passwordBlur}
          changeCallback = {passwordCallback}
          fieldType      = {passwordFieldType}
          helperText     = {passwordHelperText}
          label          = {t('UpdatePassword--submitPassword-passwordLabel')}
        />
      </PasswordFieldContainer>
      <PasswordFieldContainer>
        <PasswordInput
          blurCallback   = {confirmPasswordBlur}
          changeCallback = {confirmPasswordCallback}
          fieldType      = {confirmPasswordFieldType}
          helperText     = {confirmPasswordHelperText}
          label          = {t('UpdatePassword--submitPassword-confirmPasswordLabel')}
        />
      </PasswordFieldContainer>
      <ButtonContainer>
        <Button
          size         = {ButtonSizes.LARGE}
          width        = {ButtonWidth.FULL}
          disabled     = {isButtonDisabled}
          onClick      = {submitPasswordCallback}
          interactable = {!isLoading}
          isLoading    = {isLoading}
        >
          {t('UpdatePassword--submitPassword-buttonLabel')}
        </Button>
      </ButtonContainer>
    </ContentContainer>
  );
}

export default SubmitPassword;

